import { useSiteContent } from '../hooks/useSiteContent.ts';
import { SiteConfigRenderer } from './LandingPage.tsx';

// Aperçu du brouillon sur une vraie URL (utile pour l'ouvrir dans un nouvel
// onglet ou le partager) — l'éditeur du back-office, lui, prévisualise l'état
// en cours d'édition directement en mémoire, sans passer par cette route.
export function PreviewPage() {
  const { config, error } = useSiteContent(true);

  if (error) {
    return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-secondary)' }}>Impossible de charger l'aperçu.</div>;
  }
  if (!config) return null;

  return <SiteConfigRenderer config={config} />;
}
